import { ShopifyIcon, StripeIcon } from '@/components/icons';
import type { BrandSalesChannel } from '@fluenceur/types';
import { Shop } from 'iconoir-react';
import { SALES_CHANNEL_ICONS } from './onboarding-options';

/** The logo of a sales channel, or a shop pictogram before one is chosen. */
export const StoreLogo = ({
  channel,
  size,
}: {
  channel: BrandSalesChannel | null;
  size: number;
}) => {
  if (channel === 'shopify') return <ShopifyIcon boxSize={`${size}px`} />;
  if (channel === 'stripe') return <StripeIcon boxSize={`${size}px`} />;

  const Icon = (channel && SALES_CHANNEL_ICONS[channel]) || Shop;
  return <Icon width={size} height={size} color="var(--chakra-colors-ink)" aria-hidden />;
};
